/**
 * @generated SignedSource<<30ed40fda9273a6061e56d9558ca15b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemAssignees_employees$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemEmployees_employees">;
  readonly " $fragmentType": "ListItemAssignees_employees";
}>;
export type ListItemAssignees_employees$key = ReadonlyArray<{
  readonly " $data"?: ListItemAssignees_employees$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemAssignees_employees">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ListItemAssignees_employees",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListItemEmployees_employees"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "f2c584fb9f49b2711861b7c04dd2f0a5";

export default node;
